import { publishMetapropertyOptionSearch, publishTextSearch } from './publishSearchAssets';
import type { MetapropertyOptionSearch, MetapropertySearchParams, TextSearchParams } from './types';

export type SearchToEmit =
	| [params: TextSearchParams]
	| [params: MetapropertySearchParams, metapropertyOption: MetapropertyOptionSearch];

/** Context for AI: the search boundary to paramount — publishes the search on the `asset-bank/search` topic. The topic and its payload are a cross-repo contract; don't change them unilaterally. */
export const emitSearchAssetsEvent = (isHybridSearchOn: boolean, ...search: SearchToEmit) => {
	const isMetapropertySearch = search.length === 2;

	if (isMetapropertySearch) {
		const [, metapropertyOption] = search;
		const { metaproperty, option } = metapropertyOption;
		publishMetapropertyOptionSearch(isHybridSearchOn, metaproperty, option);

		return;
	}

	const [textSearchParams] = search;
	publishTextSearch(isHybridSearchOn, textSearchParams);
};
